import React, { useEffect } from "react";
import classes from "./contactUs.module.css";
import Footer from "../../components/footer";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className={classes.contactContainer}>
        <h1>Contact Us</h1>
        <p className={classes.txt}>
          If you have any questions, concerns, or feedback about this policy,
          reach out to us at
          <strong>
            {" "}
            <a href="mailto:support@artistnextdoor.in">
              support@artistnextdoor.in
            </a>
          </strong>
          .
        </p>
        <p className={classes.txt}>
          We value your privacy and are here to help.
        </p>
        <p className={classes.txt}>
          At <strong>Artist Next Door</strong>, privacy isn’t just a policy—it’s
          a promise. Thanks for trusting us to be part of your creative journey!
        </p>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
